import { gettext } from '@eventbrite/i18n';
import React from 'react';
import OrganizerCard from '../OrganizerCard/OrganizerCard';
import { Organizer } from '../utils';
import './OrganizerCardsContainer.scss';

export interface OrganizerCardsContainerProps {
    organizersList: Organizer[];
}

const OrganizerCardsContainer: React.FunctionComponent<
    OrganizerCardsContainerProps
> = ({ organizersList }) => {
    return (
        <div
            className="ttd-organizer-cards-container"
            data-testid="ttd-organizer-cards-container"
        >
            <div className="ttd-organizer-cards-container__cards-wrapper">
                {organizersList.map((organizer: Organizer) => {
                    return (
                        <div
                            key={organizer.id}
                            className="ttd-organizer-cards-container__card-wrapper"
                        >
                            <OrganizerCard
                                id={organizer.id}
                                imageUrl={organizer.image_url}
                                isFollowing={organizer.followed_by_you}
                                organizerName={organizer.name}
                                subtitle={gettext(
                                    '%(followerCount)s followers',
                                    {
                                        followerCount:
                                            organizer.num_followers || 0,
                                    },
                                ).toString()}
                                organizerUrl={organizer.url}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default OrganizerCardsContainer;
